import React, { useEffect, useState, useContext } from "react";
import "./VoyahDreamWarranty.css";

import modesLine from "../../../../assets/images/voyahdream/warranty/drivingModes.png";
import warrantyBadge from "../../../../assets/images/voyahfree/warranty/warrantylabel2.png";
import carImage from "../../../../assets/images/voyahdream/warranty/warrantyBack.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const VoyahDreamWarranty = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await getPageContent("voyahdream", currentLang);

        // response.sections.warranty
        setData(response.sections);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  const { warranty } = data;
  const yearsText = warranty.warranty_years || "";
  const yearsNumber = yearsText.split(" ")[0] || "";
  const yearsLabel = yearsText.split(" ").slice(1).join(" ") || "";
  const subText = warranty.warranty_sub || "";
  const subWords = subText.split(" ");
  const subMid = Math.ceil(subWords.length / 2);
  const subLine1 = subWords.slice(0, subMid).join(" ");
  const subLine2 = subWords.slice(subMid).join(" ");

  return (
    <section className="voyahdream-warranty-section">
      {/* TOP TEXT */}
      <div className="voyahdream-warranty-header">
        <p className="voyahdream-warranty-sub">
          {warranty.subtitle}
        </p>
        <p className="voyahdream-warranty-main">
          {warranty.main_text}
        </p>
      </div>

      {/* DRIVING MODES LINE */}
      <div className="voyahdream-warranty-modes-line">
        <img src={modesLine} alt="Driving modes" />
        <div className="voyahdream-elipse"></div>
      </div>

      {/* VISUAL */}
      <div className="voyahdream-warranty-visual">
        <img
          src={carImage}
          className="voyahdream-warranty-car"
          alt="Car"
        />

<div className="voyahdream-warranty-badge">
  <img
    src={warrantyBadge}
    className="voyahdream-warranty-badge-bg"
    alt="Warranty background"
  />

  <div className="voyahdream-warranty-badge-text">
    <div className="voyahdream-warranty-title">
      {warranty.warranty_label}
    </div>

<div className="voyahdream-warranty-years">
  <span className="voyahdream-warranty-years-number">
    {yearsNumber}
  </span>
  <br />
  <span className="voyahdream-warranty-years-label">
    {yearsLabel}
  </span>
</div>

    <div className="voyahdream-warranty-km">
      {subLine1}
      {subLine2 ? <><br />{subLine2}</> : null}
    </div>
  </div>
</div>
      </div>
    </section>
  );
};

export default VoyahDreamWarranty;
